import React, { useState, useCallback, useEffect, forwardRef } from "react";
import {
  FormLayout,
  TextField,
  Text,
  Stack,
  RadioButton,
  Checkbox,
} from "@shopify/polaris";

const HeightStyle = (props) => {
  const handleChangeHeight = (_checked, newValue) => {
    props.handleChangeHeight(_checked, newValue);
  };
  const handleChangeMinimumHeight = (newValue) => {
    props.handleChangeMinimumHeight(newValue);
  };
  const handleChangeMaximumHeight = (newValue) => {
    props.handleChangeMaximumHeight(newValue);
  };
  const handleChangeCustomHeight = (newValue) => {
    props.handleChangeCustomHeight(newValue);
  };
  const handleChangeHeightMobile = (_checked, newValue) => {
    props.handleChangeHeightMobile(_checked, newValue);
  };
  const handleChangeMinimumHeightMobile = (newValue) => {
    props.handleChangeMinimumHeightMobile(newValue);
  };
  const handleChangeMaximumHeightMobile = (newValue) => {
    props.handleChangeMaximumHeightMobile(newValue);
  };
  const handleChangeCustomHeightMobile = (newValue) => {
    props.handleChangeCustomHeightMobile(newValue);
  };
  const handleChangeMobileHeight = (newValue) => {
    props.handleChangeMobileHeight(newValue);
  };
  const [checkedMobileHeight, setCheckedMobileHeight] = useState(
    props?.item?.height?.customHeight ? true : false
  );
  const handleChangeCheckedMobileHeight = useCallback(
    (newChecked) => setCheckedMobileHeight(newChecked),
    []
  );
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        SECTION HEIGHT
      </Text>
      <Text variant="headingXs" as="h6">
        DESKTOP
      </Text>
      <Stack horizontal>
        <RadioButton
          label="Minimum/Maximum Height"
          checked={props.item.height.type.desktop === "1"}
          id="1"
          onChange={handleChangeHeight}
        />
        <RadioButton
          label="Custom Height"
          id="2"
          checked={props.item.height.type.desktop === "2"}
          onChange={handleChangeHeight}
        />
        <RadioButton
          label="Full Screen Height"
          id="3"
          checked={props.item.height.type.desktop === "3"}
          onChange={handleChangeHeight}
        />
        <RadioButton
          label="Adapt to image"
          id="4"
          checked={props.item.height.type.desktop === "4"}
          onChange={handleChangeHeight}
        />
      </Stack>
      {props.item.height.type.desktop === "1" && (
        <FormLayout.Group condensed>
          <TextField
            label="Minumum Height"
            value={props.item.height.minimumHeight.desktop}
            onChange={handleChangeMinimumHeight}
            type="number"
          />
          <TextField
            label="Maximum Height"
            value={props.item.height.maximumHeight.desktop}
            onChange={handleChangeMaximumHeight}
            type="number"
          />
        </FormLayout.Group>
      )}
      {props.item.height.type.desktop === "2" && (
        <TextField
          label="Custom Height"
          value={props.item.height.customHeight.desktop}
          onChange={handleChangeCustomHeight}
          type="number"
        />
      )}
      {/* <Checkbox
        label="Add Custom Mobile Height"
        checked={checkedMobileHeight}
        onChange={handleChangeCheckedMobileHeight}
      />
      {checkedMobileHeight && (
        <TextField
          label="Mobile Height"
          value={props.item.height.mobileHeight}
          onChange={handleChangeMobileHeight}
          type="number"
        />
      )} */}

      <Text variant="headingXs" as="h6">
        MOBILE
      </Text>
      <Stack horizontal>
        <RadioButton
          label="Minimum/Maximum Height"
          checked={props.item.height.type.mobile === "5"}
          id="5"
          onChange={handleChangeHeightMobile}
        />
        <RadioButton
          label="Custom Height"
          id="6"
          checked={props.item.height.type.mobile === "6"}
          onChange={handleChangeHeightMobile}
        />
        <RadioButton
          label="Full Screen Height"
          id="7"
          checked={props.item.height.type.mobile === "7"}
          onChange={handleChangeHeightMobile}
        />
        <RadioButton
          label="Adapt to image"
          id="8"
          checked={props.item.height.type.mobile === "8"}
          onChange={handleChangeHeightMobile}
        />
      </Stack>
      {props.item.height.type === "5" && (
        <FormLayout.Group condensed>
          <TextField
            label="Minumum Height"
            value={props.item.height.minimumHeight.mobile}
            onChange={handleChangeMinimumHeightMobile}
            type="number"
          />
          <TextField
            label="Maximum Height"
            value={props.item.height.maximumHeight.mobile}
            onChange={handleChangeMaximumHeightMobile}
            type="number"
          />
        </FormLayout.Group>
      )}
      {props.item.height.type.mobile === "6" && (
        <TextField
          label="Custom Height"
          value={props.item.height.customHeight.mobile}
          onChange={handleChangeCustomHeightMobile}
          type="number"
        />
      )}
    </FormLayout>
  );
};

export default HeightStyle;
